import styled from 'styled-components'

export const BroadcastContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .cardBroadcastArtist {
    margin-left: 18px;
    margin-right: 10px;
    margin-bottom: 12px;
  }
  .cardText {
    font-family: StolzlLight,serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.57;
    letter-spacing: normal;
  }
  .cardNow {
    font-family: StolzlMedium,serif;
    color: #933ec5;
    margin-right: 7px;
  }
  .cardStageName {
    font-family: StolzlMedium,serif;
    margin: 25px 10px 15px 18px;
  }
  .stagePhoto {
    height: 110px;
    img { 
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      width: 270px;
      height: 110px;
      object-fit: cover;
    }
  }
  .broadcastCard {
    width: 270px;
    position: relative;
    box-shadow: 0 2px 10px 0 rgba(192, 192, 192, 0.5);
    border-radius: 10px;
    margin-bottom: 30px;
    :not(:last-child) {
      margin-right: 50px;
    }
    :nth-child(4n) {
      margin-right: 0;
    }
    @media (max-width: 1400px) {
      :not(:last-child) {
      margin-right: 0;
    }
    }
    button, a {
      border: none;
      background: none;
      padding: 0;
      position: absolute;
      top: 83px;
      right: 20px;
      cursor: pointer;
    }
    &--selected {
      box-shadow: 0 2px 6px 0 rgb(147 62 197 / 40%);
    }
    .stream-btn {
      height: 50px;

      &--pulse {
        animation: radial-pulse 0.8s infinite;
        border-radius: 50%;
      }
      :hover {
        opacity: 0.8;
      }
    }
  }
  @keyframes radial-pulse {
    0% { box-shadow: 0 0 0 0px rgba(147, 62, 197, 0.5); }  
    100% { box-shadow: 0 0 0 10px rgb(243 243 243 / 0%); }
  }

  .broadcastInfoBar {
    @media (max-width: 470px) {
      margin-left: 20px;
    }
  }
  .otherBroadcastsList {
    margin-top: 0;
    display: flex;
    width: 1400px;
    margin-bottom: 40px;
    justify-content: center;
    flex-wrap: wrap;
    @media (max-width: 1400px) {
        width: 100%;
        justify-content: space-evenly;
    }
  }
  .broadcastPlaceholder {
    background-color: #080707;
    width: 100%;
    height: 100%;
    border-radius: 20px;
  }
  .broadcastWindow {
    margin: 50px auto 27px;
    width: 90vw;
    max-width: 900px;
    position: relative;
    
    padding-bottom: 56.25%;
    height: 0;
     
    @media (max-width: 450px) {
      margin-top: 20px;
    }
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      border: none;
      border-radius: 20px;
      width: 100%;
      height: 100%;
    }
    button {
      border: none;
      background: none;
      padding: 0;
      position: absolute;
      top: calc(50% - 26px);
      right: calc(50% - 25px);
      cursor: pointer;
    }
    img {
      position: absolute;
      height: 100%;
      width: 100%;
    }
    //.windowContainer {
    //  height: 100%;
    //  width: 100%;
    //}
  }
  .currentBroadcastArtist {
    font-size: 16px;
    letter-spacing: 2px;
    color: #080707;
    margin-top: 17px;
    
    a {
      text-decoration: none;
      
      :hover {
        text-decoration: underline;
      }
    }
  }
  .currentBroadcastStage {
    font-family: StolzlMedium, serif;
    font-size: 20px;
    letter-spacing: 2px;
    color: #000000;
    text-decoration: none;
    
    :hover {
      text-decoration: underline;
    }
  }
  .now {
    font-family: StolzlMedium, serif;
    font-size: 16px;
    letter-spacing: 2px;
    color: #933ec5;
    margin-right: 7px;
  }
  h1 {
    text-transform: uppercase;
    margin-top: 180px;
    font-family: StolzlBold, serif;
    font-size: 50px;
    color: #000000;
    @media (max-width: 850px) {
      font-size: 30px;
      line-height: 1.5;
      margin-top: 100px;
    }
    @media (max-width: 770px) {
      margin-top: 0;
    }
    @media (max-width: 520px) {
      font-size: 20px;
    }
    @media (max-width: 420px) {
      font-size: 18px;
    }
  }
  
  .partnersContainer {
    margin-top: 25px;
    margin-bottom: 0;
    
        .general, .official {
      width: 160px !important;
      height: 160px !important;
      @media (max-width: 768px) {
        width: 140px !important;
        height: 140px !important;
      }
      @media (max-width: 510px) {
        width: 140px !important;
        height: 140px !important;
      }
    }
    .title, .consul, .media {
      width: 90px !important;
      height: 90px !important;
      @media (max-width: 768px) {
        width: 90px !important;
        height: 90px !important;
      }
      @media (max-width: 510px) {
        width: 80px !important;
        height: 80px !important;
      }
    }
  }
`
